/* eslint-disable import/prefer-default-export */
declare global {
  interface Window {
    heap: any
  }
}

export const heapTrack = (eventName: string, data?: any) => {
  if (window.heap) {
    window.heap?.track(eventName, data)
  }
}

export const HeapEvent = {
  V4LightDarkModeToggle: 'V4LightDarkModeToggle',
  V4DahboardRefeshClick: 'V4DahboardRefeshClick',
  V4DashboardCategoryClick: 'V4DashboardCategoryClick',
  V4SearchKeyword: 'V4SearchKeyword',
  V4DashboardSortClick: 'V4DashboardSortClick',
  V4DashboardPdfExportClick: 'V4DashboardPdfExportClick',
  V4DashboardListPinToggle: 'V4DashboardListPinToggle',
  V4ExitNewDashboardClick: 'V4ExitNewDashboardClick',
  V4PresentationModeClick: 'V4PresentationModeClick',
  V4DashboardListFilterClick: 'V4DashboardListFilterClick',
  V4DashboardLabelSelected: 'V4DashboardLabelSelected',
  V4DashboardReportSelected: 'V4DashboardReportSelected',
  V4DashboardTutorialClick: 'V4DashboardTutorialClick',
  V4DashboardTableHeaderSelected: 'V4DashboardTableHeaderSelected'
}

export const HeapEventPage = {
  DashboardView: 'DashboardView',
  DashboardHome: 'DashboardHome'
} as const

export type HeapEventPageKey = keyof typeof HeapEventPage
export type HeapEventPageValue = typeof HeapEventPage[HeapEventPageKey]
